import gettext, { ngettext } from '@sdk/lang/gettext';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';
import { User } from '@sdk/users/types/User';

import { Emoji, ReactionsMap } from '@web/conversations/types/Reactions';
import { Badge } from '@web/conversations/Reactions/types/Badge';
import { EMOJI_NAMES } from '@web/conversations/Reactions/consts/emojiNames';

export const formatLabel = (usernames: string[], reactionName: string): string => {
  const usernamesCount = usernames.length;

  if (usernamesCount === 0) return '';

  const lastIndex = usernamesCount - 1;

  return ngettext(
    '%(firstUserName)s reacted with %(reactionName)s',
    '%(userNames)s and %(lastUserName)s reacted with %(reactionName)s',
    usernamesCount,
    {
      firstUserName: usernames[0],
      userNames: usernames.slice(0, lastIndex).join(', '),
      lastUserName: usernames[lastIndex],
      reactionName,
    }
  );
};

type CreateBadgeProps = {
  currentUser: AuthUserType;
  reactions: ReactionsMap;
  personas: PersonasDict;
};

export const createBadges = ({ currentUser, reactions, personas }: CreateBadgeProps): Badge[] => {
  const currentUserReactions = reactions[currentUser.id] || [];

  const reactionNamesMap = Object.entries(reactions).reduce<Record<Emoji, string[]>>(
    (map, [userId, emojis]) => {
      const label = (personas[userId] as User)?.fullname || gettext('[deleted employee]');

      emojis.forEach((emoji) => {
        if (map[emoji]) {
          map[emoji].push(label);
        } else {
          map[emoji] = [label];
        }
      });

      return map;
    },
    {}
  );

  const badges = Object.entries(reactionNamesMap)
    .sort()
    .map<Badge>(([emoji, names]) => ({
      counter: names.length,
      emoji,
      label: formatLabel(names, EMOJI_NAMES[emoji]),
      isSelected: currentUserReactions.includes(emoji),
    }));

  return badges;
};
